import React from "react";

import styles from "./Board.module.scss";
import Image from "../Global/Image";
import Button from "../Global/Button";
import Link from "../Pictos/Link";

export default function Board ({ image, buttonUrl = 'https://www.boursier.com/dossiers/les-semi-conducteurs-avec-etoro', buttonText = "Lire l'article", picto = true, rtl = false, classname = null, children }) {
    return (
        <div className={[styles.Main, rtl ? 'rtl' : '', classname ?? ''].join(' ')}>
            <div className={styles.Text}>
                { children }
                <Button text={buttonText} url={buttonUrl}>
                    {
                        picto ? <Link/> : null
                    }
                </Button>
            </div>

            <Image src={image.src} srcRet={image.srcRet} webp={image.webp} webpRet={image.webpRet} alt={buttonText}/>
        </div>
    )
}
